import React from 'react'
import CardContainer from '../Card/CardContainer'
import useForm from '../../../hooks/useForm'
import ValidateInput from '../Form/ValidateInput'

function EditExtdFields(props) {
    const {
        handleChange,
        handleSubmit,
        setValues,
        updateError,
        values,
        errors
    } = useForm(savePersonCallback, validate);

    React.useEffect(() => {
        setValues(props.bowlerProfile || {});
    }, []);

    function savePersonCallback() {
        props.onUserInfoSave(values);
    }

    function validate(name, value, displayName) {
        let key = name.replace(/_/g," ")
        value = value.replace(/,/g,";")
        if(key in values.extdFields)
            values.extdFields[key] = value;
        
        return value;
    }

    return (
        values != null &&
        <CardContainer title="Additional Details">
            <div className='row mt-3'>
                {
                    Object.keys(values.extdFields).map((key, i) => (
                        <div className="col-md-6" key={i}>
                            <label htmlFor={key.replace(/ /g,"_")} className="form-label">{key}</label>
                            <ValidateInput errors={errors}>
                                <input type="text" className="form-control" id={key.replace(/ /g,"_")} name={key.replace(/ /g,"_")} value={values.extdFields[key] || ""} onChange={handleChange}/>
                            </ValidateInput>
                        </div>
                    ))
                }
            </div>
        </CardContainer>
    )
};

export default EditExtdFields;

